import { isBrowser } from "../browser.mjs";
/**
 * Singleton Class
 */
class PendingChangesHelper {
    static instance = new PendingChangesHelper();
    static forms = [];
    message = 'Changes you made may not be saved.';
    discardCallback = () => { };
    constructor() {
        if (isBrowser) {
            window.onbeforeunload = () => {
                if (PendingChangesHelper.pending()) {
                    return this.message;
                }
            };
        }
    }
    static getInstance() {
        return PendingChangesHelper.instance;
    }
    addForm(form) {
        if (PendingChangesHelper.forms.indexOf(form) === -1) {
            PendingChangesHelper.forms.push(form);
        }
    }
    removeForm(form) {
        const formIndex = PendingChangesHelper.forms.indexOf(form);
        if (formIndex > -1) {
            PendingChangesHelper.forms.splice(formIndex);
        }
    }
    checkForm(form) {
        return PendingChangesHelper.forms.includes(form);
    }
    static pendingForms() {
        return PendingChangesHelper.forms;
    }
    static pending() {
        return PendingChangesHelper.forms.length > 0;
    }
    guard() {
        return (to, from, next) => {
            const { dialog: dTo, 'simple-dialog': sdTo } = to.query;
            const { dialog: dFrom, 'simple-dialog': sdFrom } = from.query;
            const isADialogURL = (dTo !== dFrom || sdTo !== sdFrom);
            if (!isADialogURL && PendingChangesHelper.pending()) {
                if (confirm(this.message)) {
                    PendingChangesHelper.forms = [];
                    this.discardCallback();
                    next();
                }
                else {
                    return false;
                }
            }
            else {
                next();
            }
        };
    }
    onDiscard(callback) {
        this.discardCallback = callback;
    }
}
export default PendingChangesHelper.getInstance();
//# sourceMappingURL=PendingChangesHelper.mjs.map